
import { PageHeader, MuiAutocomplete } from "../../components"
import { Stack, Grid } from "@mui/material"
import { Link } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";

export const HeaderDropDown = ({ name, assessmentTypeData,batchAssessmentListViewData, assessmentType, setAssessmentBatch, assessmentBatch, heading, setAssessmentType,isBatch, isCustomer, ...props }) => {
    return (
        <Stack

            {...props}
            flexDirection="row"
        // justifyContent="space-around"
        // alignItems="center"
        // spacing={2}
        >
            <Grid
                container
                style={{
                    display: "flex",
                    padding: 0,
                    margin: 0
                    // alignItems: "start",
                    // marginBottom: "0.5rem",
                    //   background:"red"
                }}
            >
                <Grid item xs={12} sm={12} md={3}>
                    {isBatch && <MuiAutocomplete
                        name="assessmentBatch"
                        options={batchAssessmentListViewData?.data?.length > 0 ? batchAssessmentListViewData?.data : [] }
                        setValue={(name, newValue) => setAssessmentBatch(newValue)}
                        value={assessmentBatch}
                        size="small"
                        height="100%"
                        fullWidth={true}
                        noMargin
                        optionValue={"name"}
                        // optionSecValue="code"
                        label={name ? name : "Select or Search Batch"}
                    />}


                    {isCustomer && <MuiAutocomplete
                        name="assessmentType"
                        options={assessmentTypeData}
                        setValue={(name, newValue) => setAssessmentType(newValue)}
                        value={assessmentType}
                        size="small"
                        height="100%"
                        fullWidth={true}
                        noMargin
                        optionValue={name ? "name" : "assessmentType"}
                        // optionSecValue="code"
                        label={name ? name : "Customer Name"}
                    />}

                </Grid>

                {isCustomer && <Grid sx={{ml:1}} item xs={12} sm={12} md={3}>
                    <MuiAutocomplete
                        name="assessmentType"
                        options={assessmentTypeData}
                        setValue={(name, newValue) => setAssessmentType(newValue)}
                        value={assessmentType}
                        size="small"
                        height="100%"
                        fullWidth={true}
                        noMargin
                        optionValue={name ? "name" : "assessmentType"}
                        // optionSecValue="code"
                        label={name ? name : "Account Name"}
                    />

                </Grid>}

                <Grid item xs={12} sm={12} md={isCustomer ? 3 : 6}>
                {!isCustomer && !isBatch && <PageHeader variant="pageHeader">{heading}</PageHeader>}
                </Grid>

                <Grid item xs={12} sm={12} md={2.8} >
                    <MuiAutocomplete
                        name="assessmentType"
                        options={assessmentTypeData}
                        setValue={(name, newValue) => setAssessmentType(newValue)}
                        value={assessmentType}
                        size="small"
                        height="100%"
                        fullWidth={true}
                        noMargin
                        optionValue={name ? "name" : "assessmentType"}
                        // optionSecValue="code"
                        label={name ? name : "Assessment Type"}
                    />

                </Grid>
            </Grid>
        </Stack>
    )

}